<distribution-edit
    [trackingSpecificationId]="dataset.specificationId"
    [manualDownload]="true"
    [selectionChanged]="selectionChanged"
    (form)="setForm($event)"
></distribution-edit>
<div class="alert alert-danger mt-3">
    {{ "DOWNLOAD.ALERT_1" | translate }} &nbsp;<a href="/documents/Nutzungsbedingung.pdf" target="_blank">{{ "DOWNLOAD.TERMS" | translate }}</a>
    {{ "DOWNLOAD.ALERT_2" | translate }}
</div>
